<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <el-table class="table" :data="tableData" style="width: 100%" border :height="400">
          <el-table-column label="Imei号" prop="imei" width="200"></el-table-column>

          <el-table-column label="高压" prop="highBloodPressure"></el-table-column>
          <el-table-column label="低压" prop="lowBloodPressure"></el-table-column>
          <el-table-column label="心率" prop="heartBeats"></el-table-column>
          <el-table-column label="胆固醇" prop="cholesterol"></el-table-column>
          <el-table-column label="甘油三酯" prop="triglyceride"></el-table-column>
          <el-table-column label="尿酸" prop="uricAcid"></el-table-column>
          <el-table-column label="血糖" prop="bloodSugar"></el-table-column>

          <el-table-column label="时间" prop="createTime" :formatter="timefilter" width="200"></el-table-column>
        </el-table>

        <div class="page">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
          </div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5_with_china} from "@/common/Base64MD5";

export default {
  name: 'Data',
  data() {
    return {
      showModalAdd:false,

      loading: false,

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      imei:'',

      bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.bodyStyle = "height:"+(val+50)+'px';
      this.th=val
    },
  },
  methods: {

    init(imei){
      console.log(imei);
      this.imei = imei;
      this.getData()
    },



    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    closeSelf() {
      this.$emit("closeData");
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getData();
    },

    getTime(row,index,column){
      return timefilters(column)
    },

    getData(){
      this.loading = true;

      let data = {
        timeStr: timeStr,
        sign: "",
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        imei:this.imei,
      };

      data.sign = "";
      data.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(data) + "&key="+this.$signKey)


      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceNanXueRecord/PageByImei",
        data: data,
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.tableData=response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },

  }
}


</script>


